module.exports = __webpack_public_path__ + "img/28.e7ee27f4.png";